import {$} from './provider';


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var COLOR = function COLOR(name) {
    switch (name) {
        case 'pink':
            return 'rgba(240, 224, 250, 1)';
        case 'green':
            return 'rgba(209, 242, 244, 1)';
        case 'blue':
            return 'rgba(207, 226, 247, 1)';
    }
};
var COLOR_DARK = function COLOR_DARK(name) {
    switch (name) {
        case 'pink':
            return 'rgba(225, 194, 245, 1)';
        case 'green':
            return 'rgba(163, 229, 234, 1)';
        case 'blue':
            return 'rgba(159, 197, 239, 1)';
    }
};
var RANDOM_BETWEEN = function RANDOM_BETWEEN(min, max) {
    return min + (max - min) * Math.random();
};
var RANDOM_AROUND = function RANDOM_AROUND(x, y, d) {
    return {
        x: RANDOM_BETWEEN(x - d, x + d),
        y: RANDOM_BETWEEN(y - d, y + d)
    };
};
var BEZIER = function BEZIER() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, 0, 0, 0];
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return Math.pow(1 - t, 3) * params[0] + 3 * Math.pow(1 - t, 2) * t * params[1] + 3 * (1 - t) * Math.pow(t, 2) * params[2] + Math.pow(t, 3) * params[3];
};

export const requestAnimFrame = function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
        window.setTimeout(callback, 1000 / 60);
    };
}();
export const cancelRequestAnimFrame = function () {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout;
}();

export const mainAnimation = function () {
    function mainAnimation(selector) {
        var _this = this;

        var mobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _classCallCheck(this, mainAnimation);

        var canvas_el = document.querySelector(selector);
        this.mobile = mobile;
        this.images = {};
        var mobileParticles = [{ id: 1, x: -13, y: 80, s: 20, colorName: 'blue', bridge: [2, 3, 6] }, { id: 2, x: 50, y: 55, s: 20, colorName: 'blue', bridge: [6, 3, 5] }, { id: 3, x: 125, y: 46, s: 30, colorName: 'blue', bridge: [2, 5, 4] }, { id: 4, x: 150, y: 43, s: 15, colorName: 'blue', bridge: [3] }, { id: 5, x: 160, y: 140, s: 32, colorName: 'blue', bridge: [2, 3] }, { id: 6, x: 82, y: 160, s: 48, colorName: 'blue', bridge: [7, 8, 2, 1] }, { id: 7, x: 0, y: 150, s: 30, colorName: 'blue', bridge: [] }, { id: 8, x: 120, y: 210, s: 30, colorName: 'blue', bridge: [10] }, { id: 9, x: 20, y: 270, s: 15, colorName: 'blue', bridge: [] }, { id: 10, x: 160, y: 250, s: 20, colorName: 'blue', bridge: [11] }, { id: 11, x: 180, y: 260, s: 15, colorName: 'blue', bridge: [10] }, { id: 12, x: 10, y: 225, s: 30, colorName: 'blue', bridge: [9, 10, 7, 8] }, { id: 13, x: 215, y: 85, s: 30, colorName: 'green', bridge: [5, 2] }, { id: 14, x: 265, y: 160, s: 30, colorName: 'green', bridge: [13, 6, 8] }, { id: 15, x: 245, y: 230, s: 20, colorName: 'green', bridge: [8, 10, 6] }, { id: 16, x: 285, y: 45, s: 15, colorName: 'green', bridge: [] }, { id: 17, x: 320, y: 70, s: 25, colorName: 'green', bridge: [14, 16] }, { id: 18, x: 390, y: 100, s: 32, colorName: 'green', bridge: [17, 13, 14] }, { id: 19, x: 408, y: 180, s: 40, colorName: 'green', bridge: [18, 15, 14] }, { id: 20, x: 340, y: 235, s: 32, colorName: 'green', bridge: [19, 15, 14, 20] }, { id: 21, x: 330, y: 260, s: 15, colorName: 'green', bridge: [20] }, { id: 22, x: 520, y: 115, s: 35, colorName: 'green', bridge: [18] }, { id: 23, x: 475, y: 160, s: 25, colorName: 'green', bridge: [22] }, { id: 24, x: 550, y: 150, s: 20, colorName: 'green', bridge: [22] }, { id: 25, x: 475, y: 78, s: 15, colorName: 'pink', bridge: [18, 19, 22] }, { id: 26, x: 505, y: 210, s: 20, colorName: 'pink', bridge: [19, 20, 25] }, { id: 27, x: 550, y: 78, s: 30, colorName: 'pink', bridge: [25, 22] }, { id: 28, x: 590, y: 140, s: 20, colorName: 'pink', bridge: [27, 24] }, { id: 29, x: 617, y: 186, s: 30, colorName: 'pink', bridge: [24, 28] }, { id: 30, x: 650, y: 120, s: 35, colorName: 'pink', bridge: [27, 26] }, { id: 31, x: 685, y: 20, s: 35, colorName: 'pink', bridge: [27, 30] }, { id: 32, x: 695, y: 70, s: 25, colorName: 'pink', bridge: [31, 30] }, { id: 33, x: 700, y: 120, s: 15, colorName: 'pink', bridge: [30] }, { id: 34, x: 750, y: 105, s: 25, colorName: 'pink', bridge: [31, 32, 29] }, { id: 35, x: 760, y: 165, s: 30, colorName: 'pink', bridge: [34, 28] }, { id: 36, x: 775, y: 44, s: 20, colorName: 'pink', bridge: [31, 34] }, { id: 37, x: 800, y: 240, s: 20, colorName: 'pink', bridge: [28, 36, 35] }];

        this.params = {
            dur: {
                lineK: 2,
                point: 600,
                text: 300
            },
            showID: false,
            onHoverColor: function onHoverColor(c) {
                return false;
            },
            onMouseLeave: function onMouseLeave() {
                return false;
            }
        };
        this.pJS = {
            canvas: {
                el: canvas_el,
                w: canvas_el.offsetWidth,
                h: canvas_el.offsetHeight
            },
            bridges: [],
            particles: [{ id: 1, x: 381, "y": 7, "s": 14, colorName: 'pink', "bridge": [2, 4] }, { id: 2, "x": 506, "y": 47, "s": 20, colorName: 'pink', "bridge": [] }, {
                id: 3,
                "x": 259,
                "y": 70,
                "s": 20,
                colorName: 'pink',
                "bridge": [4, 2],
                text: 'sharing',
                textTop: true
            }, {
                id: 4,
                "x": 430,
                "y": 130,
                "s": 30,
                text: 'online', textTop: true,
                colorName: 'pink',
                "bridge": [1, 2, 5, 8, 3]
            }, { id: 5, "x": 331, "y": 159, "s": 40, colorName: 'pink', "bridge": [3, 4] }, {
                id: 6,
                "x": 356,
                "y": 281,
                "s": 20,
                text: 'knowledge management', textTop: true, textW: 235,
                colorName: 'pink',
                "bridge": [5]
            }, { id: 7, "x": 465, "y": 294, "s": 14, colorName: 'pink', "bridge": [6] }, {
                id: 8,
                "x": 489,
                "y": 204,
                "s": 30,
                text: 'web-application', textTop: true, textW: 165,
                colorName: 'pink',
                "bridge": [5, 7, 4, 2]
            }, { id: 9, "x": 623, "y": 82, "s": 30, colorName: 'pink', text: 'distant', "bridge": [2, 10] }, {
                id: 10,
                "x": 568,
                "y": 174,
                "s": 14,
                colorName: 'pink',
                "bridge": [8, 9]
            }, { id: 11, "x": 655, "y": 12, "s": 20, colorName: 'pink', "bridge": [9] }, {
                id: 12,
                "x": 760,
                "y": 90,
                "s": 20,
                colorName: 'pink',
                "bridge": [9, 10]
            }, { "s": 12, colorName: 'pink', id: 13, "bridge": [5], "x": 271, "y": 195 }, {
                "s": 30,
                colorName: 'pink',
                id: 14,
                "bridge": [10, 2],
                "x": 692,
                "y": 205
            }, { "s": 20, colorName: 'green', id: 15, "bridge": [10, 14], "x": 606, "y": 231 }, {
                "s": 40,
                colorName: 'green',
                id: 16,
                text: 'teamwork', textTop: true, textW: 118,
                "bridge": [15, 8, 7],
                "x": 597,
                "y": 325
            }, { "s": 20, colorName: 'green', id: 17, "bridge": [16], "x": 680, "y": 363 }, {
                "s": 45,
                colorName: 'green',
                id: 18,
                text: 'network science', textTop: true,
                "bridge": [6, 7],
                "x": 365,
                "y": 350
            }, {
                "s": 30,
                colorName: 'green',
                id: 19,
                "bridge": [],
                text: 'research team',
                textTop: true,
                "x": 516,
                "y": 528
            }, {
                "s": 30,
                colorName: 'green',
                id: 20,
                text: 'projects', textTop: true,
                "bridge": [18, 21, 35, 38, 32, 19, 25],
                "x": 367,
                "y": 527
            }, {
                "s": 35,
                colorName: 'green',
                id: 21,
                "bridge": [6, 18, 23],
                textW: 128,
                text: 'community',
                "x": 256,
                "y": 397
            }, {
                "s": 35,
                colorName: 'green',
                id: 22,
                "bridge": [18, 7, 16, 25, 19, 20],
                "x": 461,
                "y": 418
            }, { "s": 12, colorName: 'green', id: 23, "bridge": [], "x": 215, "y": 417 }, {
                "s": 20,
                colorName: 'green',
                id: 24,
                "bridge": [21, 18, 38, 35, 30],
                "x": 251,
                "y": 527
            }, { "s": 30, colorName: 'green', id: 25, "bridge": [], "x": 557, "y": 433 }, {
                "s": 12,
                colorName: 'green',
                id: 26,
                "bridge": [25],
                "x": 608,
                "y": 449
            }, { "s": 12, colorName: 'blue', id: 27, "bridge": [], "x": 79, "y": 518 }, {
                "s": 12,
                colorName: 'blue',
                id: 28,
                "bridge": [],
                "x": 60,
                "y": 666
            }, { "s": 12, colorName: 'blue', id: 29, "bridge": [34], "x": 651, "y": 757 }, {
                "s": 24,
                colorName: 'blue',
                id: 30,
                text: 'graphs', textTop: true, textW: 88,
                "bridge": [31, 27],
                "x": 129,
                "y": 554
            }, {
                "s": 22,
                colorName: 'blue',
                id: 31,
                "bridge": [30, 28],
                textW: 83,
                text: 'model',
                "x": 120,
                "y": 645
            }, {
                "s": 22,
                colorName: 'blue',
                id: 32,
                "bridge": [19, 37, 34, 36, 38, 20],
                "x": 518,
                "y": 613
            }, { "s": 22, colorName: 'blue', id: 33, "bridge": [31, 35, 38, 36], "x": 240, "y": 731 }, {
                "s": 30,
                colorName: 'blue',
                id: 34,
                "bridge": [],
                text: 'classification',
                textW: 140,
                "x": 585,
                "y": 666
            }, {
                "s": 35,
                colorName: 'blue',
                id: 35,
                text: 'text', textTop: true, textW: 63,
                "bridge": [24, 30, 31, 33, 38],
                "x": 215,
                "y": 612
            }, {
                "s": 30,
                colorName: 'blue',
                id: 36,
                "bridge": [38, 32, 34, 33],
                text: 'scientific visualization',
                textW: 212,
                "x": 358,
                "y": 732
            }, {
                "s": 35,
                colorName: 'blue',
                id: 37,
                "bridge": [34, 32, 19],
                text: 'semantics',
                textW: 115,
                "x": 652,
                "y": 561
            }, {
                "s": 45,
                colorName: 'blue',
                "id": 38,
                "bridge": [],
                textW: 108,
                text: 'statistics',
                "x": 354,
                "y": 619
            }]
        };

        if (mobile) {
            this.pJS.particles = mobileParticles;
        }

        this.textAnimationPercent = 0;
        this.pJS.particles.forEach(function (p) {
            p.a = 0;
            p.y += 10;
            p.first = p.id === 8 || p.id === 22;
            p.start = p.id === 8 || p.id === 22 ? 10 : 0;

            p.color = COLOR_DARK(p.colorName);
        });
        this.animations = [{ points: this.pJS.particles }];
        this.animation = {};
        new Array(10).join('0').split('').forEach(function () {
            _this.animations.push({
                lines: [],
                points: _this.pJS.particles.map(function (zero, i) {
                    var point = _this.pJS.particles[i];
                    return Object.assign({ id: i + 1 }, RANDOM_AROUND(point.x, point.y, 10), {
                        s: point.s,
                        color: point.color,
                        a: 1
                    });
                })
            });
        });
        this.init();
    }

    _createClass(mainAnimation, [{
        key: 'init',
        value: function init() {
            this.canvasInit();
            this.canvasSize();
            this.canvasPaint();
            this.initBridges();
            this.setStartAnimation();
            this.calcLinesAnimation();
            this.initHovers();
            this.start();
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.removeHovers();
            cancelAnimationFrame(this.tick);
            this.playing = false;
            this.canvasClear();
        }
    }, {
        key: 'canvasInit',
        value: function canvasInit() {
            this.canvas = {
                ctx: this.pJS.canvas.el.getContext('2d')
            };
        }
    }, {
        key: 'removeHovers',
        value: function removeHovers() {
            $(this.pJS.canvas.el).parent().find('.animWrapper__hover').remove();
        }
    }, {
        key: 'updateHovers',
        value: function updateHovers(scale) {
            this.removeHovers();
            this.initHovers(scale);
        }
    }, {
        key: 'initHovers',
        value: function initHovers() {
            var _this2 = this;

            var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var $root = $(this.pJS.canvas.el).parent();
            this.pJS.particles.filter(function (p) {
                return p.text;
            }).forEach(function (p) {
                var $el = $('<div class="animWrapper__hover"></div>');
                $root.append($el);
                $el.css({
                    width: (p.s + (p.textW ? p.textW : 20 + p.text.length * 10)) * scale,
                    height: (p.s / 3 + p.s / 2 + 40) * scale,
                    top: (p.textTop ? p.y - 40 - p.s / 3 : p.y - p.s / 2) * scale,
                    left: (p.x - p.s / 2) * scale
                });
                $el.on('mouseover', function () {
                    _this2.setActive(p.colorName);
                    _this2.params.onHoverColor(p.colorName);
                });
                $el.on('mouseleave', function () {
                    _this2.setActive('all');
                    _this2.params.onMouseLeave();
                });
            });
        }
    }, {
        key: 'similarPoints',
        value: function similarPoints(point) {
            return this.pJS.particles.filter(function (p) {
                return p.colorName === point.colorName && p.text;
            });
        }
    }, {
        key: 'calcLinesAnimation',
        value: function calcLinesAnimation() {
            var _this3 = this;

            this.animations.forEach(function (cadr) {
                var getPoint = function getPoint(id) {
                    return cadr.points.filter(function (p) {
                        return p.id === id;
                    })[0];
                };
                cadr.lines = _this3.pJS.bridges.map(function (line) {
                    var a = getPoint(line.a.id),
                        b = getPoint(line.b.id);

                    return {
                        a: a,
                        b: b,
                        width: 10,
                        color: line.color
                    };
                });
            });
        }
    }, {
        key: 'canvasSize',
        value: function canvasSize() {
            var _this4 = this;

            this.resize();
            $(window).on('resize', function () {
                clearTimeout(_this4.resizeTimeout);
                _this4.resizeTimeout = setTimeout(function () {
                    _this4.resize();
                }, 500);
            });
        }
    }, {
        key: 'resize',
        value: function resize() {
            var orWidth = 780,
                adaptive = $(window).width() < 1008;

            var scale = function scale() {
                var w = $(window).width();
                if (adaptive) return w / 780;

                if (w < 1600) {
                    return w * 0.4 / orWidth;
                }

                return 1;
            };

            var s = 1 / scale(),
                w = $(this.pJS.canvas.el).width() * s,
                h = $(this.pJS.canvas.el).height() * s;

            this.pJS.canvas.el.width = w;
            this.pJS.canvas.el.height = h;
            this.pJS.canvas.w = w;
            this.pJS.canvas.h = h;

            this.updateHovers(scale());
        }
    }, {
        key: 'canvasPaint',
        value: function canvasPaint() {
            //this.canvas.ctx.fillRect(0, 0, this.pJS.canvas.w, this.pJS.canvas.h);
        }
    }, {
        key: 'canvasClear',
        value: function canvasClear() {
            this.canvas.ctx.clearRect(0, 0, this.pJS.canvas.w, this.pJS.canvas.h);
        }
    }, {
        key: 'drawPoint',
        value: function drawPoint(point) {
            var r = point.s / 2;

            //
            if (point.a < 1) {
                this.canvas.ctx.fillStyle = 'rgba(0,0,0,0)';
                this.canvas.ctx.strokeStyle = point.color;
                this.canvas.ctx.lineWidth = 2;
                this.canvas.ctx.beginPath();
                this.canvas.ctx.arc(point.x, point.y, r * BEZIER([0, 0, 1.7, 1], point.a), 0, Math.PI * 2, false);
                this.canvas.ctx.fill();
                this.canvas.ctx.stroke();
                this.canvas.ctx.closePath();

                if (point.a > .2) {
                    this.canvas.ctx.fillStyle = point.color;
                    this.canvas.ctx.beginPath();
                    this.canvas.ctx.arc(point.x, point.y, r * BEZIER([0, 0, 1.4, 1], (point.a - .2) * 1.2), 0, Math.PI * 2, false);
                    this.canvas.ctx.fill();
                    this.canvas.ctx.closePath();
                }
            } else {
                this.canvas.ctx.fillStyle = point.color;
                this.canvas.ctx.beginPath();
                this.canvas.ctx.arc(point.x, point.y, r, 0, Math.PI * 2, false);
                this.canvas.ctx.fill();
                this.canvas.ctx.closePath();
            }

            if (this.params.showID) {
                this.canvas.ctx.fillStyle = "rgba(0, 0, 0, 1)";
                this.canvas.ctx.font = "12px Open Sans";
                this.canvas.ctx.fillText(point.id, point.x, point.y);
            }
        }
    }, {
        key: 'loadImage',
        value: function loadImage(path) {
            var img = document.createElement('img');
            return new Promise(function (res) {
                img.onload = function () {
                    res(img);
                };
                img.src = path;
            });
        }
    }, {
        key: 'drawImage',
        value: function drawImage(image, point) {
            var imgScale = .43,
                imgHeight = image.height * imgScale,
                imgWidth = image.width * imgScale * this.textAnimationPercent,
                x = point.x + point.s / 2 + 10,
                y = point.textTop ? point.y - ((35 - imgHeight) / 2 + point.s / 3) - imgHeight : point.y + ((35 - imgHeight) / 2 + point.s / 3);
            this.canvas.ctx.drawImage(image, x, y, imgWidth, imgHeight);
        }
    }, {
        key: 'drawText',
        value: function drawText(point) {
            var _this5 = this;

            this.drawRoundedRect(point);

            if (point.text && this.images[point.text]) {
                this.drawImage(this.images[point.text], point);
            } else if (point.text) {
                var picName = point.text.replace(' ', '_') + '.png';
                this.loadImage('static/img/canvas/' + picName).then(function (img) {
                    _this5.images[point.text] = img;
                });

                var x = point.x + point.s / 2 + 10,
                    y = point.textTop ? point.y - point.s / 3 - 12 : point.y + point.s / 3 + 24;

                this.canvas.ctx.fillStyle = "rgba(255, 255, 255, 1)";
                this.canvas.ctx.font = "18px CocoGothic";
                this.canvas.ctx.fillText(point.text, x, y);
            }
        }
    }, {
        key: 'drawRoundedRect',
        value: function drawRoundedRect(point) {
            if (this.textAnimationPercent === 0) return;

            var R = 5,
                w = point.textW || 20 + point.text.length * 10,
                h = 35,
                x = point.x + point.s / 3,
                y = point.textTop ? point.y - h - point.s / 3 : point.y + point.s / 3;

            w = w * this.textAnimationPercent;

            this.canvas.ctx.beginPath();
            this.canvas.ctx.moveTo(x + R, y);
            this.canvas.ctx.lineTo(x + w - R, y);
            this.canvas.ctx.quadraticCurveTo(x + w, y, x + w, y + R);
            this.canvas.ctx.lineTo(x + w, y + h - R);
            this.canvas.ctx.quadraticCurveTo(x + w, y + h, x + w - R, y + h);
            this.canvas.ctx.lineTo(x + R, y + h);
            this.canvas.ctx.quadraticCurveTo(x, y + h, x, y + h - R);
            this.canvas.ctx.lineTo(x, y + R);
            this.canvas.ctx.quadraticCurveTo(x, y, x + R, y);
            this.canvas.ctx.fillStyle = point.color;
            this.canvas.ctx.fill();
            this.canvas.ctx.closePath();
        }
    }, {
        key: 'drawLine',
        value: function drawLine(line) {

            this.canvas.ctx.strokeStyle = line.color;
            this.canvas.ctx.lineWidth = 2.5;

            this.canvas.ctx.beginPath();
            this.canvas.ctx.moveTo(line.a.x, line.a.y);
            this.canvas.ctx.lineTo(line.a.x + (line.b.x - line.a.x) * line.p, line.a.y + (line.b.y - line.a.y) * line.p);
            this.canvas.ctx.stroke();
            this.canvas.ctx.closePath();
        }
    }, {
        key: 'initBridges',
        value: function initBridges() {
            var _this6 = this;

            this.pJS.particles.forEach(function (p) {
                _this6.addPointBridges(p);
            });
        }
    }, {
        key: 'getBridges',
        value: function getBridges(point) {
            this.pJS.bridges.filter(function (br) {
                return !br.started;
            }).forEach(function (br) {
                if (br.b.id === point.id) {
                    var b = br.a;
                    br.a = point;
                    br.b = b;
                }
            });

            return this.pJS.bridges.filter(function (br) {
                return br.a.id === point.id;
            });
        }
    }, {
        key: 'setBridgeStart',
        value: function setBridgeStart(point) {
            this.pJS.bridges.filter(function (br) {
                return !br.started;
            }).forEach(function (br) {
                if (br.b.id === point.id) {
                    var b = br.a;
                    br.a = point;
                    br.b = b;
                }
            });
        }
    }, {
        key: 'setStartAnimation',
        value: function setStartAnimation() {
            var _this7 = this;

            var current = this.pJS.particles.filter(function (p) {
                    return p.first;
                }),
                index = 1,
                time = 10;

            current.forEach(function (p) {
                var bridges = _this7.getBridges(p);
                bridges.forEach(function (b) {
                    _this7.setBridgeStart(p);
                    b.started = time;
                });
                bridges.forEach(function (br) {
                    return Object.assign(_this7.getPoint(br.b.id), {
                        start: br.started + br.l * _this7.params.dur.lineK,
                        index: index
                    });
                });
            });

            while (!this.pJS.particles.every(function (p) {
                return p.start || p.first || !p.bridge.length;
            }) && index < 100) {
                this.pJS.particles.filter(function (p) {
                    return p.index === index;
                }).forEach(function (p) {
                    if (!p.bridge.length) {
                        p.start = 10;
                    }
                    var bridges = _this7.getBridges(p);
                    bridges.filter(function (br) {
                        return !br.started;
                    }).forEach(function (b) {
                        _this7.setBridgeStart(p);
                        b.started = p.start;
                    });
                    bridges.forEach(function (br) {
                        return Object.assign(_this7.getPoint(br.b.id), {
                            start: br.started + br.l * _this7.params.dur.lineK,
                            index: index + 1
                        });
                    });
                });
                index++;
            }

            var max = 0;
            this.pJS.particles.forEach(function (p) {
                if (p.start > max) {
                    max = p.start;
                }
            });
            this.textStart = max + this.params.dur.point;
        }
    }, {
        key: 'unsetActive',
        value: function unsetActive() {
            this.pJS.particles.forEach(function (p) {
                p.color = COLOR(p.colorName);
            });
        }
    }, {
        key: 'setActive',
        value: function setActive(colorName) {
            this.pJS.particles.forEach(function (p) {
                if (colorName === 'all' || p.colorName === colorName) {
                    p.color = COLOR_DARK(p.colorName);
                } else {
                    p.color = COLOR(p.colorName);
                }
            });
        }
    }, {
        key: 'addPointBridges',
        value: function addPointBridges(pos) {
            var _this8 = this;

            var bridges = [];
            pos.bridge.forEach(function (id) {
                bridges.push([id, pos.id]);
            });
            bridges.forEach(function (br) {
                _this8.addBridge(br);
            });
        }
    }, {
        key: 'addBridge',
        value: function addBridge(br) {
            if (!this.checkBridgeExist(br)) {
                var _br = _slicedToArray(br, 2),
                    aID = _br[0],
                    bID = _br[1],
                    a = this.getPoint(aID),
                    b = this.getPoint(bID),
                    arColor = a.color.split(','),
                    length = Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));

                this.pJS.bridges.push({
                    a: a,
                    b: b,
                    width: 10,
                    l: length,
                    color: arColor[0] + ',' + arColor[1] + ',' + arColor[2] + ', .3)',
                    p: 0
                });
            }
        }
    }, {
        key: 'checkBridgeExist',
        value: function checkBridgeExist(bridge) {

            bridge.sort(function (a, b) {
                return a > b ? 1 : -1;
            });
            var brStr = bridge.join('-');

            return this.pJS.bridges.some(function (thisBridge) {
                return brStr === thisBridge.a.id + '-' + thisBridge.b.id;
            });
        }
    }, {
        key: 'getPoint',
        value: function getPoint(id) {
            return this.pJS.particles.filter(function (point) {
                return point.id === id;
            })[0];
        }
    }, {
        key: 'updateCanvas',
        value: function updateCanvas() {
            var _this9 = this;

            this.canvasClear();
            this.animation.lines.forEach(function (line) {
                _this9.drawLine(line);
            });
            this.animation.points.forEach(function (point) {
                _this9.drawPoint(point);
            });
            this.animation.points.filter(function (p) {
                return p.text;
            }).forEach(function (point) {
                _this9.drawText(point);
            });
        }
    }, {
        key: 'start',
        value: function start() {
            this.activeIndex = 0;
            this.play();
        }
    }, {
        key: 'finishAnimation',
        value: function finishAnimation() {
            this.activeIndex = this.activeIndex === this.animations.length - 1 ? 0 : this.activeIndex + 1;
            if (this.playing) {
                this.play();
            }
        }
    }, {
        key: 'play',
        value: function play() {
            var _this10 = this;

            this.first_tick = 0;
            this.last_tick = 0;
            this.playing = true;

            requestAnimationFrame(function (e) {
                _this10.tick(e);
            });
        }
    }, {
        key: 'updateParticles',
        value: function updateParticles(percent) {
            var _this11 = this;

            var cur = this.animations[this.activeIndex],
                next = this.animations[this.activeIndex === this.animations.length - 1 ? 0 : this.activeIndex + 1];

            if (this.textAnimationPercent !== 1) {
                var tStart = this.textStart;
                if (this.last_tick < tStart) {
                    this.textAnimationPercent = 0;
                } else if (this.last_tick - tStart < this.params.dur.text) {
                    this.textAnimationPercent = (this.last_tick - tStart) / this.params.dur.text;
                } else {
                    this.textAnimationPercent = 1;
                }
            }

            var dur = this.params.dur.point,
                A = function A(point) {

                    //Если это первая точка
                    if (point.first && !point.changed) {
                        point.start = _this11.last_tick;
                        _this11.f_tick = _this11.last_tick;
                        point.changed = true;
                        return 0;
                    }

                    if (point.start) {
                        var start = point.start + _this11.f_tick;
                        if (_this11.last_tick - start < 0) {
                            return 0;
                        }
                        if (_this11.last_tick - start > dur) {
                            point.a = 1;
                            return 1;
                        } else {
                            point.a = (_this11.last_tick - start) / dur;
                            return point.a;
                        }
                    } else {
                        return 0;
                    }
                },
                W = function W(line) {
                    if (line.started) {
                        var lineDur = line.l * _this11.params.dur.lineK,
                            start = line.started + _this11.f_tick;
                        if (_this11.last_tick - start < 0) {
                            return 0;
                        }
                        if (_this11.last_tick < start + lineDur) {
                            return (_this11.last_tick - start) / lineDur;
                        } else {
                            line.ready = true;
                            return 1;
                        }
                    } else {
                        return 0;
                    }
                };

            this.animation = {
                points: cur.points.map(function (pos, i) {
                    var nextPos = next.points[i];
                    var a = A(_this11.pJS.particles[i]);
                    return {
                        x: pos.x + (nextPos.x - pos.x) * percent,
                        y: pos.y + (nextPos.y - pos.y) * percent,
                        color: _this11.pJS.particles[i].color,
                        s: pos.s,
                        a: a,
                        id: pos.id,
                        text: _this11.pJS.particles[i].text,
                        image: _this11.pJS.particles[i].image,
                        textTop: _this11.pJS.particles[i].textTop,
                        textW: _this11.pJS.particles[i].textW
                    };
                }),
                lines: cur.lines.map(function (line, i) {
                    var nextPos = next.lines[i],
                        p = W(_this11.pJS.bridges[i]);
                    return {
                        a: {
                            x: line.a.x + (nextPos.a.x - line.a.x) * percent,
                            y: line.a.y + (nextPos.a.y - line.a.y) * percent
                        },
                        b: {
                            x: line.b.x + (nextPos.b.x - line.b.x) * percent,
                            y: line.b.y + (nextPos.b.y - line.b.y) * percent
                        },
                        color: line.color,
                        started: line.started ? line.started : false,
                        p: p
                    };
                })
            };
        }
    }, {
        key: 'tick',
        value: function tick(e) {
            var _this12 = this;

            if (this.playing && (this.last_tick - this.first_tick) / 3000 <= 1) {
                if (!this.first_tick) {
                    this.first_tick = e;
                }

                requestAnimationFrame(function (e) {
                    _this12.tick(e);
                });

                if (e - this.last_tick > 1000 / 60) {
                    // Если время после прошлого кадра больше чем заданная длительность кадра
                    this.last_tick = e; // Перезаписываем время прошлого кадра

                    var percent = (this.last_tick - this.first_tick) / 3000;
                    this.updateParticles(percent);
                    this.updateCanvas();
                }
            } else {
                this.finishAnimation();
            }
        }
    }]);

    return mainAnimation;
}();
